/**
 * ChatGPT Ads (OpenAI) Measurement Pixel — Browser-Seite.
 *
 * Wird nur auf /bewerbung geladen. Das Conversion-Event `lead_created` geht mit einer
 * `event_id` raus, die der Server über die Conversions API mit derselben ID noch einmal
 * sendet. OpenAI führt beide zusammen (Deduplizierung).
 *
 * Es werden nie Rohdaten übertragen: die E-Mail wird vorher im Browser mit SHA-256
 * gehasht, Name und Telefonnummer gehen gar nicht an den Pixel.
 */

let loadedPixelId = null;

export function loadOpenAiPixel(pixelId, debug = false) {
  if (!pixelId || typeof window === 'undefined') return false;
  if (loadedPixelId === pixelId && window.oaiq) return true;

  /* eslint-disable */
  (function (w, d, s, u) {
    if (w.oaiq) return;
    var q = function () { q.q.push(arguments); };
    q.q = [];
    w.oaiq = q;
    var js = d.createElement(s);
    js.async = true;
    js.src = u;
    var f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(js, f);
  })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');
  /* eslint-enable */

  // debug:true laesst das OpenAI-SDK jeden Aufruf in die Browser-Konsole schreiben —
  // nur zum Einrichten sinnvoll, danach OPENAI_ADS_DEBUG wieder entfernen.
  window.oaiq('init', debug ? { pixelId, debug: true } : { pixelId });
  loadedPixelId = pixelId;
  return true;
}

export function isOpenAiPixelLoaded() {
  return !!(loadedPixelId && window.oaiq);
}

/** Einwilligung nachreichen, falls später ein Cookie-Banner dazukommt. */
export function setOpenAiConsent(granted) {
  if (!window.oaiq) return false;
  window.oaiq('consent', !!granted);
  return true;
}

/** SHA-256 im Browser. Braucht einen sicheren Kontext (HTTPS oder localhost). */
export async function sha256Hex(value) {
  const v = (value || '').trim().toLowerCase();
  if (!v || !window.crypto?.subtle) return null;
  try {
    const bytes = new TextEncoder().encode(v);
    const digest = await window.crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return null;
  }
}

/**
 * Feuert `lead_created`. Vorher wird — falls möglich — die gehashte E-Mail gesetzt,
 * damit OpenAI die Conversion einem Klick zuordnen kann.
 * @returns {Promise<boolean>} ob das Event abgesetzt wurde
 */
export async function trackOpenAiLead(eventId, email) {
  if (!window.oaiq) return false;
  const emailHash = await sha256Hex(email);
  if (emailHash) window.oaiq('init', { user: { email_sha256: emailHash } });
  window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
  return true;
}
